<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'technology-pendingOrder',
  components: {
    PageTable,
  },
}
</script>
